import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { authConfig } from 'src/config/auth.config';

/**
 * Initializes the authentication service.
 * @returns None
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService {

    constructor(private oAuthService: OAuthService) {}

    public initAuth(): (() => Promise<void>) {
        return () => new Promise<void>((res, rej) => {
          this.oAuthService.configure(authConfig);
          this.oAuthService.tokenValidationHandler = new JwksValidationHandler();
          this.oAuthService.loadDiscoveryDocumentAndTryLogin().then(() => {
              this.oAuthService.setupAutomaticSilentRefresh();
              res();
          });
        });
    }

}
